export default "//yastatic.net/s3/distribution/pythia/frontend/_/80b9a60c4a9b7671636bba0a6ca15129.svg";